import React from 'react';
import { Link } from 'react-router-dom';

interface SmartLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

const SmartLink: React.FC<SmartLinkProps> = ({ to, children, className }) => {
  const isExternal = /^https?:\/\//.test(to); // Checks if the URL starts with "http://" or "https://"

  return isExternal ? (
    <a
      href={to}
      className={className}
      target='_blank'
      rel='noopener noreferrer'
    >
      {children}
    </a>
  ) : (
    <Link to={to} className={className}>
      {children}
    </Link>
  );
};

export default SmartLink;
